import { Metrics } from './metrics-model';

export const metricsMapper = (apiData: any): Metrics[] => {
  return apiData;
};
